// Adapted from davinci-elections apps/web/src/theme/recipes/typography.ts @ 6e23f58
import { defineRecipe } from '@chakra-ui/react'

const sidebarTitle = {
  pt: 4,
}

const sidebarSubtitle = {
  py: 4,
  textTransform: 'capitalize',
}

// vocdoni-app headings are regular weight with tight tracking; hierarchy comes from size (and, R113, from the section
// structure around them: a section title heads its card above a rule, a page title closes its header band).
export const heading = defineRecipe({
  base: {
    fontWeight: 'normal',
    letterSpacing: '-0.02em',
  },
  variants: {
    variant: {
      header: {
        fontWeight: 'bolder',
      },
      ['sidebar-title']: sidebarTitle,
      ['sidebar-subtitle']: sidebarSubtitle,
    },
  },
})

export const link = defineRecipe({
  base: {
    color: 'brand.fg',
    textDecoration: 'underline',
    textDecorationThickness: 'from-font',
    textUnderlineOffset: '0.15em',
    _hover: {
      color: 'brand.600',
      _dark: {
        color: 'brand.200',
      },
    },
  },
  variants: {
    variant: {
      // Chakra's default `plain` variant (applied via defaultVariants) fades the
      // underline to currentColor/20 and shifts its offset to 3px on hover,
      // fighting the base styles above — pin both so hover keeps a solid,
      // consistent underline.
      plain: {
        _hover: {
          textDecorationColor: 'currentColor',
          textUnderlineOffset: '0.15em',
        },
      },
      unstyled: {
        textDecoration: 'none',
        _hover: {
          textDecoration: 'none',
        },
      },
      icon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 'sm',
        minW: '30px',
        h: '30px',
        border: '1px solid',
        cursor: 'pointer',
        textDecoration: 'none',
      },
      footer: {
        textDecoration: 'none',
        color: 'fg.muted',
        _hover: {
          textDecoration: 'underline',
        },
      },
      button: {
        textDecoration: 'none',
      },
    },
  },
})

// Line heights are unitless so text keeps proportional spacing even when a
// consumer overrides fontSize without changing the size variant. Sizes are the
// font-size tokens (vocdoni-app's scale, floored at 16 px on the member pages).
const sizes = {
  xs: {
    fontSize: 'xs',
    lineHeight: 1.5,
  },
  sm: {
    fontSize: 'sm',
    lineHeight: 1.43,
  },
  md: {
    fontSize: 'md',
    lineHeight: 1.5,
  },
  lg: {
    fontSize: 'lg',
    lineHeight: 1.56,
  },
  xl: {
    fontSize: 'xl',
    lineHeight: 1.5,
  },
  '2xl': {
    fontSize: '2xl',
    lineHeight: 1.3,
  },
}

export const text = defineRecipe({
  variants: {
    size: sizes,
    variant: {
      subheader: {
        color: 'texts.subtle',
        fontWeight: 'normal',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
